<organization-select    #orgManager
                        autoSelectFirst = "true"
                        class           = "mr-3"
                        ></organization-select> 

<site-select            #siteManager
                        [org]           = "orgManager?.currentValue"
                        enabled         = "0"
                        autoSelectFirst = "true"
                        class           = "mr-3"></site-select>
<br>
<site-data-container    [org]     = "orgManager?.currentValue"
                        [site]    = "siteManager?.currentValue" 
                        (refresh) = "siteManager?.refreshData(orgManager?.currentValue)"></site-data-container> 
